import React from 'react';
import styles from './index.module.scss';

import { UiKit } from 'components';

/**
 * @param {React.InputHTMLAttributes<HTMLInputElement> & {
 *  title?: string,
 *  shephardId?: string
 *  isActive?: boolean,
 *  onChange?: (value: boolean, data: { event: React.ChangeEvent<HTMLInputElement>, [key: string]: any }) => void,
 *  tooltipMessage?: string
 * }} props
 */
export default function ConfigActivator({
  title = 'Activate',
  shephardId = '',
  isActive = false,
  onChange = () => {},
  tooltipMessage = '',
  ...inputProps
}) {
  return (
    <div className={styles.container} data-shepherd={shephardId}>
      <strong className={styles.label}>{title}</strong>
      <UiKit.Toggle
        isActive={isActive}
        onChange={onChange}
        tooltipMessage={tooltipMessage}
        {...inputProps}
      />
    </div>
  );
}
